// Toast
import { Suspense, useEffect } from 'react'
import 'react-toastify/dist/ReactToastify.css'
// router
import { Navigate, Route, Routes } from 'react-router-dom'

import AppToast from 'general/components/AppToast'

import store from 'app/store'

import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import { hideNotification } from 'app/appSlice'
import Search from 'features/Search'
import { useDispatch, useSelector } from 'react-redux'
// Load BS
require('bootstrap/dist/js/bootstrap.min')
// Load KT plugins
require('assets/plugins/ktutil')
require('assets/plugins/ktmenu')
require('assets/plugins/ktoffcanvas')
require('assets/plugins/ktcookie')
require('assets/plugins/kttoggle')
// aside
require('assets/plugins/aside/aside')
require('assets/plugins/aside/aside-menu')
require('assets/plugins/aside/aside-toggle')
// header
require('assets/plugins/header/ktheader-mobile')
require('assets/plugins/header/ktheader-topbar')
// dayjs
import dayjs from 'dayjs'
import 'dayjs/locale/vi'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import lf from 'dayjs/plugin/localizedFormat'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import useProjectBranding from 'hooks/useProjectBranding'

// Load the timezone and UTC plugins
dayjs.extend(timezone)
dayjs.extend(utc)
dayjs.extend(lf)
dayjs.extend(customParseFormat)

// Set the default time zone to +07:00
dayjs.tz.setDefault('Asia/Ha_Noi')
dayjs.locale('vi') // use locale globally

window.$ = window.jQuery = require('jquery')
window.moment = require('moment')
window.dayjs = dayjs
function App() {
  useProjectBranding()
  const dispatch = useDispatch()
  const { appSpinning, appNotificationModalShow, appNotificationInfo } =
    useSelector((state) => state.app)

  return (
    <Spin
      spinning={appSpinning}
      className="vw-100 vh-100"
      style={{
        maxHeight: 'none',
        position: 'fixed',
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
      }}
      size="large"
      indicator={<LoadingOutlined style={{ fontSize: 100 }} spin />}
    >
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/*" element={<Navigate to="/" />} />

          <Route path="/" element={<Search />} />
          <Route
            path="/tra-cuu-chung-tu"
            element={<Search accounting_document={1} />}
          />
        </Routes>
      </Suspense>
      {/* Toast */}
      <AppToast />
    </Spin>
  )
}

export default App
